<div class="frac-home-directions">
  <sa-lmo-frac-home-card localStorageKey="home__directions">
    <header class="flex justify-between my-1 py-1">
      <div class="flex items-center">
        <img src="/assets/icons/direction.svg" alt="Directions" class="w-4 h-4" />
        <span class="text-xl font-medium">Directions</span>
      </div>
    </header>
    <div class="flow-root ml-2 mr-2">
      <table class="w-full">
        <colgroup>
          <col class="w-10/12" />
          <col class="copy-icon" />
        </colgroup>
        <tbody>
          <tr>
            <td class="py-1 pr-3 align-middle text-pretty">
              <p class="cursor-copy direction" *ngIf="frac.direction && frac.direction.trim() !== ''; else noDirection">
                {{ frac.direction }}
              </p>
              <ng-template #noDirection>
                <p class="text-muted">No directions provided</p>
              </ng-template>
            </td>
            <td class="py-1 align-middle" *ngIf="frac.direction && frac.direction.trim() !== ''">
              <button mat-icon-button (click)="copyDirection(frac.direction)">
                <mat-icon class="cursor-pointer text-gray-600">content_copy</mat-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </sa-lmo-frac-home-card>
</div>
